// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Paso3 test Match con el snapshot 1`] = `""`;
